/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deletelisting1Inputs */

const en_deletelisting1 = /** @type {(inputs: Deletelisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Listing`)
};

const de_deletelisting1 = /** @type {(inputs: Deletelisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort löschen`)
};

/**
* | output |
* | --- |
* | "Delete Listing" |
*
* @param {Deletelisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deletelisting1 = /** @type {((inputs?: Deletelisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletelisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deletelisting1(inputs)
	return de_deletelisting1(inputs)
});
export { deletelisting1 as "deleteListing" }